module.exports = __webpack_public_path__ + "static/media/cross-roundel.b6efd447.svg";